import * as React from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { DateTime } from "luxon";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MailOutline from "@material-ui/icons/MailOutline";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import Edit from "@material-ui/icons/Edit";
import { useHistory } from "react-router-dom";
import { User } from "../../../../api/typings/Users";
import { tableStore } from "../../../../mobx/stores/TableStore/TableStore";
import { Profiles, StudentProfile } from "../../../../api/typings/Profiles";
import { UserRoleRuEnum, UserRoleEnum } from "../../../../static/enums/UserRole";
import { DialogAutoLoginMail } from "../../../../components/DialogWindow/DialogAutoLoginMail/DialogAutoLoginMail";
import { Routes } from "../../../../routes/routes";

interface StudentsProfilesTableRowProps {
  user: User;
}

function supervisorsFilter(profile: Profiles): profile is StudentProfile {
  return profile.role === UserRoleEnum.student;
}

export const StudentsProfilesTableRow = observer(({ user }: StudentsProfilesTableRowProps) => {
  const { usersProfiles } = tableStore;
  const profilesId = user.profiles.map((profile) => profile.id);
  const profilesStudents = (Object.values(usersProfiles) as Profiles[]).filter(supervisorsFilter);
  const profileInfo = profilesStudents.find((profile) => profilesId.some((id) => profile.id === id));
  if (!profileInfo) return null;
  const [open, setOpen] = useState(false);
  const history = useHistory();

  return (
    <>
      <TableRow hover>
        <TableCell>{user.id}</TableCell>
        <TableCell>
          {user.firstname} {user.lastname}
        </TableCell>
        <TableCell>{UserRoleRuEnum[profileInfo.role]}</TableCell>
        <TableCell>{DateTime.fromISO(profileInfo.created_at).toFormat("dd.MM.yyyy HH:mm")}</TableCell>
        <TableCell>{DateTime.fromISO(profileInfo.updated_at).toFormat("dd.MM.yyyy HH:mm")}</TableCell>
        <TableCell align={"right"}>
          <Tooltip title={<Typography variant={"caption"}>Редактировать</Typography>}>
            <IconButton onClick={() => handleUserInfo(user.id)}>
              <Edit color={"secondary"} fontSize={"small"} />
            </IconButton>
          </Tooltip>
          <Tooltip title={<Typography variant={"caption"}>Отправка ссылки на вход</Typography>}>
            <IconButton onClick={() => setOpen(true)}>
              <MailOutline fontSize={"small"} color={"secondary"} />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <DialogAutoLoginMail onClose={() => setOpen(false)} open={open} userId={user.id} />
    </>
  );

  function handleUserInfo(id: string): void {
    history.push(`/${Routes.user}/${id}`);
  }
});
